import TableEditor from './TableEditor.vue'
export default {
  install: function (Vue) {
    Vue.component('table-editor', TableEditor)
  }
}